import React from "react";
import { Button, Image, Popconfirm, Tag, Tooltip } from "antd";
import { ChevronRight, Pencil, Trash2 } from "lucide-react";
import { ICategory } from "../../../types/api/category";

interface GetCategoryColumnsParams {
  isParent: boolean;
  selectedId?: string | null;
  onEdit: (record: ICategory) => void;
  onDelete: (id: string) => void;
}

export function getCategoryColumns({
  isParent,
  selectedId,
  onEdit,
  onDelete,
}: GetCategoryColumnsParams) {
  return [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text: string, record: ICategory) => (
        <div className="flex items-center justify-between group">
          <div>
            <div className="font-medium text-slate-800">{text}</div>
            {record.slug && (
              <div className="text-xs text-slate-400">{record.slug}</div>
            )}
          </div>
          {isParent && selectedId === record._id && (
            <ChevronRight size={16} className="text-blue-600" />
          )}
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 100,
      render: (status: boolean) => (
        <Tag color={status ? "green" : "red"}>
          {status ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Type",
      dataIndex: "categoryType",
      key: "categoryType",
      width: 120,
      render: (categoryType?: string | null) =>
        categoryType ? (
          <Tag color="blue">
            {categoryType
              .toLowerCase()
              .split("_")
              .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
              .join(" ")}
          </Tag>
        ) : (
          <Tag>Unassigned</Tag>
        ),
    },
    {
      title: "Action",
      key: "action",
      width: 90,
      render: (_: any, record: ICategory) => (
        <div className="flex gap-1" onClick={(e) => e.stopPropagation()}>
          <Tooltip title="Edit">
            <Button
              size="small"
              icon={<Pencil size={14} />}
              onClick={() => onEdit(record)}
              className="text-slate-500 hover:text-blue-600 border-none shadow-none bg-transparent"
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Popconfirm
              title="Delete this category?"
              onConfirm={() => onDelete(record._id)}
              okText="Delete"
              okType="danger"
              cancelText="Cancel"
            >
              <Button
                size="small"
                icon={<Trash2 size={14} />}
                className="text-slate-500 hover:text-red-600 border-none shadow-none bg-transparent"
              />
            </Popconfirm>
          </Tooltip>
        </div>
      ),
    },
  ];
}
